import classNames from "classnames";
import {useFormContext} from "react-hook-form";

import {Button} from "@/components/button/Button.tsx";
import {
  Weekday,
  WeekdayDisplay,
} from "@/pages/maintenance/maintenance-create/tabs/general/MaintenanceScheduleGeneralTab.types.ts";
import {WeekdayShort} from "@/pages/maintenance/maintenance-create/tabs/general/subComponents/WeeklyRepeatOptions/WeeklyRepeatOptions.types.ts";

export const WeeklyRepeatOptions = () => {
  const {watch, setValue} = useFormContext();
  const selectedDays: string[] = watch("rrule_byweekday") ?? [];

  const toggleDay = (day: Weekday) => {
    const updated = selectedDays.includes(day) ? selectedDays.filter((d) => d !== day) : [...selectedDays, day];
    setValue("rrule_byweekday", updated, {shouldDirty: true});
  };

  return (
    <div className={"d-flex flex-column gap-2"}>
      <span className="pulseTextBodySmallBold">Repeat on</span>
      <div className={"d-flex gap-2"}>
        {Object.values(Weekday).map((day) => (
          <Button
            key={day}
            variant={"dayPicker"}
            size={"dateSquare"}
            className={classNames({active: selectedDays.includes(day)})}
            onClick={() => toggleDay(day)}
            title={WeekdayDisplay[day]}
          >
            {WeekdayShort[day]}
          </Button>
        ))}
      </div>
    </div>
  );
};
